module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-6767020e.png";